<template>
  <div>
    <!-- Card 1: título, filtro e compra (mesmo desenho do card de filtros dos usuários) -->
    <div class="lv-rounded-lg lv-border lv-text-card-foreground lv-p-3 lv-mb-4 lv-bg-white lv-shadow-sm" style="margin: 0 1.5rem 1rem 1.5rem; max-width: calc(100% - 3rem);">
      <div class="lv-flex lv-items-center lv-gap-3">
        <div class="lv-flex lv-items-center">
          <h2 class="seats-list-title">Licenças contratadas</h2>
          <span class="seats-info" tabindex="0" :aria-label="helpText">
            <span class="seats-info-badge seats-info-badge--help" aria-hidden="true">?</span>
            <span class="seats-info-card seats-info-card--below" role="tooltip">{{ helpText }}</span>
          </span>
        </div>

        <!-- Filtro (dropdown controlado, escolha única) -->
        <div
          ref="seatsFilterDropdownRef"
          class="dropdown dropdown--seats-filter"
          :class="{ 'dropdown--seats-filter-open': showFilterDropdown }">
          <button
            class="inline-flex lv-items-center lv-justify-center lv-gap-2 lv-text-sm lv-font-medium lv-rounded-md lv-px-3 lv-h-9 filter-pill lv-text-gray-700"
            type="button"
            id="seatsFilterDropdown"
            aria-haspopup="true"
            :aria-expanded="showFilterDropdown"
            style="white-space: nowrap; background-color: #f9fafb;"
            @click.stop="showFilterDropdown = !showFilterDropdown">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lv-h-4 lv-w-4 lv-mr-2">
              <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
            </svg>
            {{ filterLabel }}
          </button>
          <div
            class="dropdown-menu seats-filter-dropdown"
            aria-labelledby="seatsFilterDropdown"
            style="border-radius: 0.75rem; padding: 0.5rem; min-width: 200px;"
            @click.stop>
            <div
              v-for="option in filterOptions"
              :key="option.key"
              class="filter-dropdown-option d-flex align-items-center"
              @click="selectFilter(option.key)">
              <span class="filter-dropdown-check filter-dropdown-check--blue" :class="{ 'filter-dropdown-check--checked': filter === option.key }" aria-hidden="true">
                <svg v-if="filter === option.key" class="filter-dropdown-check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </span>
              <span class="filter-dropdown-label">{{ option.label }}</span>
              <span class="filter-dropdown-count">{{ option.count }}</span>
            </div>
          </div>
        </div>

        <div style="flex: 1;"></div>

        <button
          class="btn-purchase-seats inline-flex lv-items-center lv-justify-center lv-gap-3 lv-rounded-md lv-text-sm lv-font-medium lv-h-10 lv-px-8 lv-py-2 lv-bg-blue-600 lv-text-white lv-ml-auto"
          type="button"
          style="white-space: nowrap; color: #ffffff; border: none; outline: none; padding-left: 1rem; padding-right: 1rem; border-radius: 0.575rem;"
          @click="$emit('purchase')">
          Comprar licenças
        </button>
      </div>
    </div>

    <!-- Card 2: Listagem -->
    <div class="lv-rounded-lg lv-border lv-text-card-foreground lv-overflow-hidden lv-bg-white lv-shadow-sm" style="margin: 0 1.5rem 1.5rem 1.5rem; max-width: calc(100% - 3rem);">
      <div style="width: 100%; overflow: hidden;">
        <div class="lv-relative lv-w-full lv-overflow-auto" style="width: 100%; margin: 0; padding: 0;">
          <table class="lv-w-full lv-text-sm" style="caption-side: bottom; width: 100%; border-collapse: collapse;">
            <thead>
              <tr class="lv-bg-gray-100 lv-border-b lv-border-gray-200 transition-colors">
                <th class="lv-text-left lv-text-xs lv-font-semibold lv-text-gray-500 lv-uppercase lv-tracking-wide" style="vertical-align: middle; padding: 1rem; height: auto; color: #6b7280;">Licença</th>
                <th class="lv-text-xs lv-font-semibold lv-text-gray-500 lv-uppercase lv-tracking-wide lv-text-center" style="vertical-align: middle; padding: 1rem; height: auto; color: #6b7280;">Status</th>
                <th class="lv-text-xs lv-font-semibold lv-text-gray-500 lv-uppercase lv-tracking-wide lv-text-center" style="vertical-align: middle; padding: 1rem; height: auto; color: #6b7280;">Em uso por</th>
                <th class="lv-text-left lv-font-medium lv-text-muted-foreground" style="vertical-align: middle; padding: 1rem 0 1rem 0.5rem; height: auto; width: 50px;"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="showPendingPurchase" class="transition-colors seat-row seat-row--pending" style="border-bottom: 1px solid #e5e7eb;">
                <td class="lv-py-3" style="vertical-align: middle; padding: 0.75rem 1rem;">
                  <div class="seats-pending-plans">
                    <span v-for="item in pendingPurchase.items" :key="item.planName" class="seats-pending-plan">
                      {{ item.quantity }} ×
                      <plan-badge :plan="planNameOf(item.planName)" :code="item.planName" />
                    </span>
                  </div>
                </td>
                <td class="lv-text-center lv-py-3" style="vertical-align: middle; padding: 0.75rem 1rem;">
                  <div class="lv-flex lv-items-center lv-justify-center">
                    <span class="status-tag status-tag-awaiting">Aguardando pagamento</span>
                    <span class="seats-info" tabindex="0" :aria-label="pendingPurchaseInfo">
                      <span class="seats-info-badge" aria-hidden="true">i</span>
                      <span class="seats-info-card" role="tooltip">{{ pendingPurchaseInfo }}</span>
                    </span>
                  </div>
                </td>
                <td class="lv-text-center lv-py-3" style="vertical-align: middle; padding: 0.75rem 1rem;">
                  <span class="lv-text-gray-400">-</span>
                </td>
                <td class="lv-text-center lv-py-3 seat-actions-cell" style="vertical-align: middle; padding: 0.75rem 0 0.75rem 0.5rem;">
                  <div class="dropdown seat-actions-dropdown">
                    <button
                      class="inline-lv-flex lv-items-center lv-justify-center lv-gap-2 lv-rounded-md lv-text-sm lv-font-medium lv-h-8 lv-w-8"
                      type="button"
                      id="seat-actions-pending-purchase"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style="white-space: nowrap; background: transparent; border: none; color: #6b7280;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lv-h-4 lv-w-4 lv-text-gray-500">
                        <circle cx="12" cy="12" r="1"></circle>
                        <circle cx="19" cy="12" r="1"></circle>
                        <circle cx="5" cy="12" r="1"></circle>
                      </svg>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right seat-actions-menu" aria-labelledby="seat-actions-pending-purchase">
                      <a
                        v-if="pendingPurchase.paymentUrl"
                        class="dropdown-item d-flex align-items-center"
                        :href="pendingPurchase.paymentUrl"
                        target="_blank"
                        rel="noopener noreferrer">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 flex-shrink-0" aria-hidden="true">
                          <rect width="20" height="14" x="2" y="5" rx="2"></rect>
                          <line x1="2" x2="22" y1="10" y2="10"></line>
                        </svg>
                        Abrir cobrança
                      </a>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="#"
                        @click.prevent="showCancelPurchase = true">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 flex-shrink-0" aria-hidden="true">
                          <path d="M18 6 6 18"></path>
                          <path d="m6 6 12 12"></path>
                        </svg>
                        Cancelar compra
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="visibleSeats.length === 0 && !showPendingPurchase">
                <td colspan="4" class="text-center py-5" style="color: #6b7280;">
                  Nenhuma licença neste filtro.
                </td>
              </tr>
              <tr
                v-for="seat in paginatedSeats"
                :key="seat.seatId"
                class="hover-bg-gray-50 transition-colors seat-row"
                style="border-bottom: 1px solid #e5e7eb;">
                <td class="lv-py-3" style="vertical-align: middle; padding: 0.75rem 1rem;">
                  <plan-badge :plan="seat.plan" :code="seat.planCode" />
                </td>
                <td class="lv-text-center lv-py-3" style="vertical-align: middle; padding: 0.75rem 1rem;">
                  <div class="lv-flex lv-items-center lv-justify-center">
                    <span class="status-tag" :class="statusClass(seat)">{{ statusLabel(seat) }}</span>
                    <span v-if="isLeaving(seat)" class="seats-info" tabindex="0" :aria-label="leavingInfo(seat)">
                      <span class="seats-info-badge" aria-hidden="true">i</span>
                      <span class="seats-info-card" role="tooltip">{{ leavingInfo(seat) }}</span>
                    </span>
                  </div>
                  <div v-if="isChangingPlan(seat)" class="lv-flex lv-items-center lv-justify-center seats-plan-change">
                    <span class="status-tag status-tag-awaiting">{{ planChangeLabel(seat) }}</span>
                    <span class="seats-info" tabindex="0" :aria-label="planChangeInfo(seat)">
                      <span class="seats-info-badge" aria-hidden="true">i</span>
                      <span class="seats-info-card" role="tooltip">{{ planChangeInfo(seat) }}</span>
                    </span>
                  </div>
                </td>
                <td class="lv-text-center lv-py-3" style="vertical-align: middle; padding: 0.75rem 1rem;">
                  <template v-if="occupantOf(seat)">
                    <div class="lv-font-medium lv-text-gray-800">{{ occupantOf(seat).name || 'Sem nome' }}</div>
                    <div class="lv-text-xs lv-text-gray-500">{{ occupantOf(seat).email }}</div>
                  </template>
                  <span v-else class="lv-text-gray-400">-</span>
                </td>
                <td class="lv-text-center lv-py-3 seat-actions-cell" style="vertical-align: middle; padding: 0.75rem 0 0.75rem 0.5rem;">
                  <div v-if="hasActions(seat)" class="dropdown seat-actions-dropdown">
                    <button
                      class="inline-lv-flex lv-items-center lv-justify-center lv-gap-2 lv-rounded-md lv-text-sm lv-font-medium lv-h-8 lv-w-8"
                      type="button"
                      :id="'seat-actions-' + seat.seatId"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style="white-space: nowrap; background: transparent; border: none; color: #6b7280;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lv-h-4 lv-w-4 lv-text-gray-500">
                        <circle cx="12" cy="12" r="1"></circle>
                        <circle cx="19" cy="12" r="1"></circle>
                        <circle cx="5" cy="12" r="1"></circle>
                      </svg>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right seat-actions-menu" :aria-labelledby="'seat-actions-' + seat.seatId">
                      <a
                        v-if="isVacant(seat)"
                        class="dropdown-item d-flex align-items-center"
                        :class="{ disabled: busySeatId !== null }"
                        href="#"
                        @click.prevent="$emit('assign', seat)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 flex-shrink-0" aria-hidden="true">
                          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                          <circle cx="9" cy="7" r="4"></circle>
                          <line x1="19" x2="19" y1="8" y2="14"></line>
                          <line x1="22" x2="16" y1="11" y2="11"></line>
                        </svg>
                        Definir usuário
                      </a>
                      <a
                        v-if="isLeaving(seat)"
                        class="dropdown-item d-flex align-items-center"
                        :class="{ disabled: busySeatId !== null }"
                        href="#"
                        @click.prevent="cancelRemoval(seat)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 flex-shrink-0" aria-hidden="true">
                          <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                          <line x1="16" x2="16" y1="2" y2="6"></line>
                          <line x1="8" x2="8" y1="2" y2="6"></line>
                          <line x1="3" x2="21" y1="10" y2="10"></line>
                          <path d="m9 16 2 2 4-4"></path>
                        </svg>
                        {{ busySeatId === seat.seatId ? 'Mantendo...' : 'Manter licença' }}
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p v-if="error" class="seats-error">{{ error }}</p>

        <!-- Paginação -->
        <div v-if="visibleSeats.length > 0" class="pagination-container pagination-layout">
          <div class="per-page-selector">
            <label for="seats-per-page-dropdown" class="per-page-label">Itens por página:</label>
            <select
              id="seats-per-page-dropdown"
              v-model.number="perPage"
              class="per-page-dropdown"
              @change="currentPage = 1">
              <option v-for="n in perPageOptions" :key="n" :value="n">{{ n }}</option>
            </select>
          </div>
          <div class="pagination-center">
            Mostrando {{ (currentPage - 1) * perPage + 1 }} a {{ Math.min(currentPage * perPage, visibleSeats.length) }} de {{ visibleSeats.length }} licenças
          </div>
          <b-pagination
            v-model="currentPage"
            :total-rows="visibleSeats.length"
            :per-page="perPage"
            :limit="5"
            align="center" />
        </div>
      </div>
    </div>

    <seats-modal-shell
      :visible="showCancelPurchase"
      title="Cancelar compra de licenças"
      :busy="cancellingPurchase"
      @close="closeCancelPurchase">
      <p class="seats-modal-text">
        A cobrança de {{ pendingPurchase ? formatCurrency(pendingPurchase.value) : '' }} ({{ pendingPurchaseSummary }}) será cancelada e nenhuma licença será criada.
      </p>
      <p v-if="cancelPurchaseError" class="seats-modal-error">{{ cancelPurchaseError }}</p>
      <div class="seats-modal-footer">
        <button type="button" class="seats-modal-button seats-modal-button--secondary" :disabled="cancellingPurchase" @click="closeCancelPurchase">
          Voltar
        </button>
        <button type="button" class="seats-modal-button seats-modal-button--primary" :disabled="cancellingPurchase" @click="cancelPurchase">
          {{ cancellingPurchase ? 'Cancelando...' : 'Cancelar compra' }}
        </button>
      </div>
    </seats-modal-shell>
  </div>
</template>

<script>
import PlanBadge from '../PlanBadge.vue'
import SeatsModalShell from './SeatsModalShell.vue'
import { cancelSeatPurchase, cancelSeatRemoval } from '@/services/subscription'
import { formatCurrency } from '@/utils/currency'
import { friendlyPlainText } from '@/utils/error-message'
import { isVacantSeat, isLeavingSeat, isChangingPlanSeat, formatSeatRemovalDay, formatSeatShortDay, formatSeatLastUsableDay } from '@/utils/seats'
import { getPlanDisplayName } from '@/utils/plan-badge'

export default {
  name: 'SeatsTable',
  components: {
    PlanBadge,
    SeatsModalShell
  },
  props: {
    seats: {
      type: Array,
      required: true
    },
    // Usuários da conta, para dizer quem ocupa cada licença (seat.userId = user.uuid).
    users: {
      type: Array,
      required: true
    },
    // Catálogo de planos, para dar nome ao plano de uma troca agendada.
    pricingList: {
      type: Array,
      required: true
    },
    // Compra de licenças aguardando pagamento: não é licença ainda, então vira uma
    // linha de pacote, só em "Todas", com o link da cobrança e a opção de desistir.
    pendingPurchase: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      filter: 'all',
      showFilterDropdown: false,
      busySeatId: null,
      error: '',
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 20, 30, 50],
      showCancelPurchase: false,
      cancellingPurchase: false,
      cancelPurchaseError: '',
      helpText: 'A licença é o que você paga. Ela pode estar vinculada a um usuário ou livre para uso. Para reduzir licenças, fale com nossa equipe.'
    }
  },
  computed: {
    assignedSeats () {
      return this.seats.filter(seat => !isVacantSeat(seat))
    },
    vacantSeats () {
      return this.seats.filter(isVacantSeat)
    },
    leavingSeats () {
      return this.seats.filter(isLeavingSeat)
    },
    // "Expirando" só aparece quando há licença expirando.
    filterOptions () {
      const options = [
        { key: 'all', label: 'Todas as licenças', count: this.seats.length },
        { key: 'assigned', label: 'Em uso', count: this.assignedSeats.length },
        { key: 'vacant', label: 'Livres', count: this.vacantSeats.length }
      ]
      if (this.leavingSeats.length > 0) {
        options.push({ key: 'leaving', label: 'Expirando', count: this.leavingSeats.length })
      }
      return options
    },
    filterLabel () {
      const option = this.filterOptions.find(candidate => candidate.key === this.filter)
      return option === undefined ? 'Todas as licenças' : option.label
    },
    visibleSeats () {
      if (this.filter === 'assigned') return this.assignedSeats
      if (this.filter === 'vacant') return this.vacantSeats
      if (this.filter === 'leaving') return this.leavingSeats
      return this.seats
    },
    showPendingPurchase () {
      return this.pendingPurchase !== null && this.filter === 'all' && this.currentPage === 1
    },
    pendingPurchaseSummary () {
      if (this.pendingPurchase === null) return ''
      const count = this.pendingPurchase.quantity
      const lines = this.pendingPurchase.items.map(item => `${item.quantity} × ${this.planNameOf(item.planName)}`)
      return `${count === 1 ? '1 licença' : `${count} licenças`}: ${lines.join(', ')}`
    },
    pendingPurchaseInfo () {
      return `Compra de licenças aguardando pagamento (${formatCurrency(this.pendingPurchase.value)}). As licenças aparecem livres na lista assim que o pagamento for confirmado.`
    },
    paginatedSeats () {
      const start = (this.currentPage - 1) * this.perPage
      return this.visibleSeats.slice(start, start + this.perPage)
    }
  },
  watch: {
    filter () {
      this.currentPage = 1
    },
    'seats.length' () {
      this.currentPage = 1
    },
    // Desfeita a última expiração, o filtro "Expirando" some e quem estava nele
    // volta para todas.
    'leavingSeats.length' (count) {
      if (count === 0 && this.filter === 'leaving') this.filter = 'all'
    }
  },
  mounted () {
    document.addEventListener('click', this.handleFilterClickOutside)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleFilterClickOutside)
  },
  methods: {
    formatCurrency,
    isVacant: isVacantSeat,
    isLeaving: isLeavingSeat,
    isChangingPlan: isChangingPlanSeat,
    hasActions (seat) {
      return isVacantSeat(seat) || isLeavingSeat(seat)
    },
    closeCancelPurchase () {
      if (this.cancellingPurchase) return
      this.showCancelPurchase = false
      this.cancelPurchaseError = ''
    },
    async cancelPurchase () {
      this.cancellingPurchase = true
      this.cancelPurchaseError = ''
      try {
        await cancelSeatPurchase(this.pendingPurchase.publicId)
        this.cancellingPurchase = false
        this.closeCancelPurchase()
        this.$emit('refresh')
      } catch (err) {
        this.cancelPurchaseError = friendlyPlainText(err, 'Não foi possível cancelar a compra. Tente novamente.')
        this.cancellingPurchase = false
        this.$emit('refresh')
      }
    },
    selectFilter (key) {
      this.filter = key
      this.showFilterDropdown = false
    },
    handleFilterClickOutside (event) {
      const filterElement = this.$refs.seatsFilterDropdownRef
      if (filterElement && !filterElement.contains(event.target)) this.showFilterDropdown = false
    },
    // O catálogo do portal só traz os planos à venda hoje; licença de plano que saiu
    // da venda (ex.: Suporte) leva o nome que o billing mandou para ela.
    planNameOf (planCode) {
      const plan = this.pricingList.find(candidate => candidate.code === planCode)
      if (plan) return plan.name
      const seat = this.seats.find(candidate => candidate.planCode === planCode && candidate.plan)
      return seat ? seat.plan : getPlanDisplayName(planCode)
    },
    // Troca de plano agendada para a virada: "Ilimitado > Negociação em 30/10".
    planChangeLabel (seat) {
      return `${seat.plan} > ${this.planNameOf(seat.pendingPlanCode)} em ${formatSeatShortDay(seat.planChangeActivateAt)}`
    },
    planChangeInfo (seat) {
      return `Na renovação da assinatura, em ${formatSeatRemovalDay(seat.planChangeActivateAt)}, esta licença passa para o plano ${this.planNameOf(seat.pendingPlanCode)}. Até ${formatSeatLastUsableDay(seat.planChangeActivateAt)} ela segue no plano ${seat.plan}.`
    },
    occupantOf (seat) {
      if (isVacantSeat(seat)) return null
      return this.users.find(user => user.uuid === seat.userId) || null
    },
    statusLabel (seat) {
      if (isLeavingSeat(seat)) return `Expira em ${formatSeatShortDay(seat.removalActivateAt)}`
      return isVacantSeat(seat) ? 'Livre' : 'Em uso'
    },
    // Licença ocupada também pode expirar (o Suporte agenda): na virada do ciclo ela
    // sai e quem está nela é desativado.
    leavingInfo (seat) {
      const removalDay = formatSeatRemovalDay(seat.removalActivateAt)
      const lastUsableDay = formatSeatLastUsableDay(seat.removalActivateAt)
      if (isVacantSeat(seat)) {
        return `Esta licença expira em ${removalDay}: a partir desse dia deixa de ser cobrada. Até ${lastUsableDay} ela continua disponível para uso.`
      }
      const occupant = this.occupantOf(seat)
      const occupantName = occupant ? occupant.name : 'o usuário'
      return `Esta licença expira em ${removalDay}. Até ${lastUsableDay} ${occupantName} continua usando; depois o usuário é desativado.`
    },
    statusClass (seat) {
      if (isLeavingSeat(seat)) return 'status-tag-awaiting'
      return isVacantSeat(seat) ? 'seats-status--vacant' : 'status-tag-active'
    },
    async cancelRemoval (seat) {
      if (this.busySeatId !== null) return
      this.busySeatId = seat.seatId
      this.error = ''
      try {
        await cancelSeatRemoval(seat.seatId)
        this.$emit('refresh')
      } catch (err) {
        this.error = friendlyPlainText(err, 'Não foi possível desfazer a saída da licença. Tente novamente.')
      } finally {
        this.busySeatId = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.seats-pending-plans {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.seats-pending-plan {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.8125rem;
  color: #374151;
  font-weight: 600;
}
.seat-row--pending {
  background-color: #fffbeb;
}
// Mesmo desenho da lista de usuários (List.vue): o estilo de lá é scoped e não
// alcança este componente.
.seats-list-title {
  font-size: 1rem;
  font-weight: 700;
  color: #111827;
  margin: 0;
  white-space: nowrap;
}
.btn-purchase-seats {
  transition: background-color 0.2s ease;
  &:hover {
    background-color: #2058cf !important;
  }
}
.seats-status--vacant {
  background-color: #eff6ff;
  color: #1d4ed8;
  border-color: #bfdbfe;
}
.seats-plan-change {
  margin-top: 0.375rem;
}
.seats-info {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
  margin-left: 0.375rem;
  outline: none;
}
.seats-info-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  height: 1rem;
  border-radius: 9999px;
  border: 1px solid #b45309;
  color: #b45309;
  font-size: 0.6875rem;
  font-weight: 700;
  cursor: help;
}
.seats-info-badge--help {
  border-color: #9ca3af;
  color: #6b7280;
}
.seats-info-card {
  display: none;
  position: absolute;
  z-index: 20;
  bottom: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  width: 16rem;
  padding: 0.5rem 0.75rem;
  background-color: #111827;
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.4;
  text-align: left;
  border-radius: 0.375rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.2);
  white-space: normal;
}
.seats-info-card--below {
  bottom: auto;
  top: calc(100% + 6px);
}
.seats-info:hover .seats-info-card,
.seats-info:focus .seats-info-card {
  display: block;
}
.seats-error {
  color: #b91c1c;
  font-size: 0.8125rem;
  margin: 0.75rem 1rem 0 1rem;
}

tr.seat-row:has(.seat-actions-dropdown.show) {
  position: relative;
  z-index: 1050;
}
.seat-actions-cell {
  position: relative;
  z-index: 1;

  &:has(.seat-actions-dropdown.show) {
    z-index: 1051;
  }
}
.seat-actions-menu {
  z-index: 1052 !important;
}

.dropdown--seats-filter {
  position: relative;

  .dropdown-menu {
    display: none;
  }
}
.dropdown--seats-filter.dropdown--seats-filter-open .dropdown-menu {
  display: block !important;
}
.seats-filter-dropdown {
  .filter-dropdown-option {
    padding: 0.5rem;
    cursor: pointer;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background-color: transparent;
    transition: background-color 0.15s ease;

    &:hover {
      background-color: #f3f4f6;
    }
  }

  .filter-dropdown-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    border-radius: 50%;
    border: 2px solid #2563eb;
    background-color: transparent;
    transition: background-color 0.15s;

    &--blue.filter-dropdown-check--checked {
      background-color: #2563eb;
    }

    &--checked .filter-dropdown-check-icon {
      color: #fff;
    }
  }

  .filter-dropdown-check-icon {
    width: 12px;
    height: 12px;
    flex-shrink: 0;
    color: transparent;
  }

  .filter-dropdown-label {
    font-size: 0.875rem;
    color: #374151;
  }

  .filter-dropdown-count {
    margin-left: auto;
    font-size: 0.75rem;
    color: #6b7280;
  }
}

.pagination-container {
  position: relative;
  border-top: 1px solid rgba(229, 231, 235, 0.5);
  margin-top: 0 !important;
  padding: 1rem 1.5rem 1.5rem 1.5rem;

  transition: border-color 0.2s ease;
}

.pagination-layout {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  .per-page-selector {
    flex: 0 0 auto;
  }

  .pagination-center {
    flex: 1 1 auto;
    min-width: 0;
    text-align: center;
    color: #6b7280;
    font-size: 0.875rem;
  }
}

.per-page-selector {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.per-page-label {
  margin: 0;
  font-size: 0.8125rem;
  font-weight: 400;
  color: #9ca3af;
  line-height: 2rem;
  white-space: nowrap;
}

.per-page-dropdown {
  min-width: 4.5rem;
  height: 2rem;
  padding: 0 0.5rem 0 0.75rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #374151;
  line-height: 1.25;
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.5rem center;
  padding-right: 1.75rem;
  transition: border-color 0.15s ease, background-color 0.15s ease;
  vertical-align: middle;

  &:hover {
    background-color: #f3f4f6;
    border-color: #d1d5db;
  }

  &:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/seats/SeatsTable.vue